import { Navigate } from "react-router-dom";

export function LocalModelBenchmarkRoute() {
  return <Navigate replace to="/" />;
}
